<script>
import { mapState, mapActions, mapGetters } from 'vuex'

import { Plugins } from '@capacitor/core'
const { Haptics } = Plugins

export default {
  name: 'ItemsList',
  props: {
    items: { type: Array, required: true }
  },
  data: () => ({
    sheet: false,
    selectedItem: null,
    scrolling: false
  }),
  computed: {
    ...mapGetters('cart', ['cartConfig']),
    ...mapState({
      totalCount(state) {
        const product = this.selectedItem
        const item = state.cart.items.find(x => x.id === product.id)
        let nowhave = 0

        state.cart.items.map(x => (nowhave += x.quantity))
        nowhave = nowhave - item.quantity + product.quantity

        return nowhave
      }
    }),
    amount() {
      if (!this.selectedItem) return 0
      const { quantity, price } = this.selectedItem

      return quantity * price
    },

    left() {
      if (!this.selectedItem) return 0
      const { quantity, left } = this.selectedItem

      return left - quantity
    }
  },
  methods: {
    ...mapActions('cart', ['changeProductQuantity']),

    openSheet(item) {
      this.sheet = true
      this.selectedItem = { ...item }
    },

    closeSheet() {
      this.sheet = false
      this.selectedItem = null
    },

    decrement() {
      if (!this.selectedItem || this.selectedItem.quantity <= 0) return

      this.selectedItem.quantity--
    },

    increment() {
      if (!this.selectedItem) return
      const { clamp } = this.lodash
      const { quantity, left } = this.selectedItem

      const oldQuantity = this.selectedItem.quantity
      this.selectedItem.quantity = clamp(quantity + 1, 0, left)
      if (this.totalCount > this.cartConfig.maxCheckoutQuantity) {
        this.selectedItem.quantity = oldQuantity
        this.$toast.error(
          `Max ${this.cartConfig.maxCheckoutQuantity} portions per order`
        )
      }
    },

    updateItem() {
      if (!this.selectedItem) return
      const product = { ...this.selectedItem }
      const { quantity } = product

      this.changeProductQuantity({ product, quantity }).then(this.closeSheet)
    }
  }
}
</script>

<template>
  <v-layout class="checkout-items-list" row wrap="" px-3 mt-5>
    <v-list>
      <v-list-item
        v-for="item in items"
        :key="item.id"
        class="body-2 px-5"
        @click="openSheet(item)"
      >
        <span class="flex-grow-1 black--text"
          >{{ item.quantity }}× {{ item.name }}</span
        >
        <div class="secondary--text ml-4">
          <!-- {{ item.currencyCode }} -->
          RM {{ (item.quantity * item.price) | round(2, true) }}
        </div>
      </v-list-item>
    </v-list>
    <v-bottom-sheet v-model="sheet" inset>
      <v-sheet v-if="selectedItem" class="checkout-bottom-sheet pt-5 pb-6">
        <!-- Item name -->
        <h4 class="flex-grow-1 subtitle-1 font-weight-bold">
          {{ selectedItem.name }}
        </h4>
        <!-- Quantity controls -->
        <div class="d-flex justify-center my-4">
          <v-btn
            :disabled="selectedItem.quantity <= 0"
            class="mx-2"
            outlined
            rounded
            fab
            small
            color="secondary"
            @click="decrement"
          >
            <v-icon size="16">$vuetify.icons.remove</v-icon>
          </v-btn>
          <h4 class="display-1 font-weight-bold px-6">
            {{ selectedItem.quantity }}
          </h4>
          <v-btn
            :disabled="left <= 0"
            class="mx-2"
            outlined
            rounded
            fab
            small
            color="secondary"
            @click="increment"
          >
            <v-icon size="16">$vuetify.icons.add</v-icon>
          </v-btn>
        </div>
        <div class="secondary--text pb-4">
          New price: RM {{ amount | round(2) }}
        </div>
        <!-- Submit -->
        <v-btn
          rounded
          class="checkout-btn"
          depressed
          color="primary"
          @click="updateItem"
        >
          <span v-if="selectedItem.quantity > 0">Update order</span>
          <span v-else>Remove item</span>
        </v-btn>
      </v-sheet>
    </v-bottom-sheet>
  </v-layout>
</template>

<style lang="sass">
.checkout-items-list
  .v-list
    width: 100%

.checkout-bottom-sheet
  text-align: center
  h4
  .v-badge
    .v-badge__badge
      top: -12px
      left: 100%
      height: 20px
    span
      white-space: nowrap
      padding: 0 4px
      font-size: 12px
</style>
